import React from 'react';
import { Container } from 'react-bootstrap';
import { GiBrain } from 'react-icons/gi';
import { ImRocket } from 'react-icons/im';
import { TiStarFullOutline } from 'react-icons/ti';
import './Services.css';



const Services = () => {
    return (
  <div class="services pt-5 pb-5">
    <Container class="">
      <div class="mt-4 pb-5">
        <p className="text-white text-start fs-5">We Provide</p>
        <h2 className="title serviceText text-start">Services</h2>
        <strong className="effect"></strong>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 p-2" data-aos="fade-right">
          <div class="icon-box text-white">
            <div class="icon"><TiStarFullOutline style={{"fontSize":"30px"}}/></div>
            <h6 style={{"color":"rgb(188 139 255)"}}>MERN-STACK-DEVLOPMENT</h6>
            <p>Qualified web designs and attractive effects which catches visitor's Eye.</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 p-2" data-aos="fade-left">
          <div class="icon-box text-white">
            <div class="icon"><ImRocket style={{"fontSize":"30px"}}/></div>
            <h6 style={{"color":"rgb(188 139 255)"}}>DESIGN + DEVLOPMENT</h6>
            <p>Clean, Modern designs optimized for performance, search engines and converting users to customers.</p>
          </div>
        </div>

       <div class="col-lg-4 col-md-4 p-2" data-aos="fade-right">
          <div class="icon-box text-white">
            <div class="icon"><ImRocket style={{"fontSize":"30px"}}/></div>
            <h6 style={{"color":"rgb(188 139 255)"}}>ECOMMERCE</h6>
            <p>Integration of ecommmerce platform, payment gateway, custom templates, and more.</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 p-2" data-aos="fade-up">
          <div class="icon-box text-white">
            <div class="icon"><ImRocket style={{"fontSize":"30px"}}/></div>
            <h6 style={{"color":"rgb(188 139 255)"}}>ANALYTICS</h6>
            <p>Gets insight into who is browing your site so that you can make smarter business decisions.</p>
          </div>
        </div>

        <div data-aos="fade-up" class="col-lg-4 col-md-4 p-2">
          <div class="icon-box text-white">
            <div class="icon"><GiBrain style={{"fontSize":"30px"}}/></div>
            <h6 style={{"color":"rgb(188 139 255)"}}>BRAINSTORIMING</h6>
            <p>I define your competition and target audience, then design your website accordingly.</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 p-2" data-aos="fade-left">
          <div class="icon-box text-white">
            <div class="icon"><ImRocket style={{"fontSize":"30px"}}/></div>
            <h6 style={{"color":"rgb(188 139 255)"}}>CONTENT-MANAGEMENT</h6>
            <p>Its very simple, You can easily update, Manage your content without knowing Coding.</p>
          </div>
        </div>
       </div>
    </Container>
  </div>

    );
};

export default Services;